import { filter } from 'lodash'
import { debounce } from 'throttle-debounce'
import * as React from 'react'
import { connect } from 'react-redux'

import { isFixedSizeEmbed } from 'embed/constants'

import * as commonActions from 'common/actions'
import { loadingErrorSelector, loadingSelector } from 'embed/selectors/loading'
import { DepositsOffer } from 'embed/constants/models'
import { MultiProductState } from 'embed/reducers'
import { DepositsSortOption, OfferType, Product, QueryParamKeys, RedirectType, SortDirection } from 'even-ts-static'
import { SingleOfferView } from './index'
import { uiViewportHeightSelector, uiViewportWidthSelector, useCompactListItemSelector } from 'embed/selectors/ui'
import { depositsSortedSavingsOffersSelector } from 'embed/selectors/rates'

interface Props {
  dispatchFetchDepositsRateTables: () => void
  dispatchOfferCta?: (offer: DepositsOffer) => void
  dispatchSortChanged?: (sortOption: DepositsSortOption, sortDirection: SortDirection) => null
  error: boolean
  loading: boolean
  offer?: DepositsOffer
  useCompactListItem: boolean
  viewportHeight?: number
  viewportWidth?: number
}

const SingleOfferContainer = class extends React.Component<Props> {
  constructor(props: Props) {
    super(props)
    props.dispatchFetchDepositsRateTables()
  }

  render() {
    return <SingleOfferView {...this.props} />
  }
}

const mapStateToProps = (state: MultiProductState, ownProps) => {
  const depositsOffers = ownProps.depositsOffers ?? depositsSortedSavingsOffersSelector(state)

  const offerUuid = state.config[QueryParamKeys.Offer]
  const viewportHeight = uiViewportHeightSelector(state)
  const viewportWidth = uiViewportWidthSelector(state)
  const useCompactListItem = useCompactListItemSelector(state)

  const offer = filter(depositsOffers, { uuid: offerUuid })[0]

  return {
    error: loadingErrorSelector(state, Product.Deposits),
    loading: loadingSelector(state, Product.Deposits),
    offer,
    useCompactListItem,
    viewportHeight,
    viewportWidth,
  }
}

export const debouncedFetch = debounce(500, (dispatch) => dispatch(commonActions.fetchRateTables(Product.Deposits)))

const mapDispatchToProps = (dispatch) => ({
  dispatchFetchDepositsRateTables: () => debouncedFetch(dispatch),
  dispatchOfferCta: (offer: DepositsOffer) =>
    dispatch(
      commonActions.redirectToOffer(offer, OfferType.Deposits, RedirectType.MANUAL, {
        openInNewTab: isFixedSizeEmbed(),
      }),
    ),
})

export const SingleOffer = connect(mapStateToProps, mapDispatchToProps)(SingleOfferContainer)
